<template>
  <div style="height: 100%;overflow: auto;">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
    </grid>
  </div>
</template>

<script>
  import Grid from '../../../../components/grid/grid'
  import GridMenuA from '../../../../components/grid-menu/grid-menu-a'
  export default {
    components: {
      Grid,
      GridMenuA
    },
    name: 'schedule-record',
    data() {
      return {
        gridConfigUrl: '/entity/scheduler/scheduleRecordShow/abstractGrid',
        jobKey: this.$route.query.jobKey,
        triggerKey: this.$route.query.triggerKey,
        clientId: this.$route.query.clientId
      }
    },
    methods: {
      back: function () {
        this.$router.back()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/grid/scheduler/schedule-record.vue